import React from 'react';
import Radium from 'radium';
import Article from './article.js';

class Contact extends Article {
  // overwrite parent
  componentDidMount(){}

  render() {
    const style = this.getStyle();
    return (
      <div style={ style.article}>
        <h1
          ref="headline" 
          id={ this.props.headlineId }
          style={[style.reset, style.h1]}>
          Kontakt
        </h1>
        <p style={[style.reset, style.text]}>
          Rechtsanwältin Birgitt Kadler übernimmt Mandate grundsätzlich im ganzen Bundesgebiet, ihre Kanzlei finden Sie aber im Herzen von Berlin:<br />
          <br />
          <a target="_blank" href="https://www.google.de/maps/place/Schliemannstraße+48,+10437+Berlin/@52.5410258,13.4159544,19z/data=!4m5!3m4!1s0x47a851ffe3352d43:0x79c6065fc5698d56!8m2!3d52.54107!4d13.41637">
            Kanzlei Birgitt Kadler<br />
            Schliemannstraße 48,<br />
            10437 Berlin<br />
          </a>
          <br />
          Gut zu erreichen u.a. mit der U-Bahn (Eberswalder Straße) oder der S-Bahn (Prenzlauer Berg).<br />
          <br />
          Einen Termin können Sie telefonisch oder per E-Mail vereinbaren unter:<br />
          <br />
          Telefon: <a href="tel:+49 (30) 444 08 38">+49 (30) 444 08 38</a><br />
          E-Mail: <a href="mailto:birgitt.kadler@t-online.de">birgitt.kadler@t-online.de</a><br />
        </p>
        <hr style={style.hr}/>
      </div>
    );
  }
}

export default Radium(Contact);


// WEBPACK FOOTER //
// ./src/modules/contact-article.js